import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/ibs`;

export const fetchBuildingCount = async (data) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/count/${data.country}`,
    {
      params: {
        quarter: data.quarter,
        scoreFrom: data.scoreFrom,
        scoreTo: data.scoreTo,
        level: data.level,
        levelVal: data.levelVal,
        buildNames: data.buildNames,
        buildTypes: data.buildTypes,
      },
      hideLoader: true
    }
  );
  return response.data;
};

export const fetchBuildingSearchOptions = async (data, page, limit) => {
  const params = {
    quarter: data.quarter,
    northEast: data.northEast,
    southWest: data.southWest,
    level: data.level,
    levelVal: data.levelVal,
    ct: data.ct,
    type: data.type,
    scoreFrom: data.scoreFrom,
    scoreTo: data.scoreTo,
    searchKey: data.searchKey,
    searchVal: data.searchVal,
    limit: limit,
    page: page,
  }
  if (data.op) params.op = data.op;
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/search/${data.country}`,
    {
      clearCacheEntry: data.level ? false : true,
      params,
      hideLoader: true
    }
  );
  return response.data;
};


export const getOptrIBSMapData = async (data, cancelToken, perPage, page = 1) => {
  const requestBody = {
    quarter: data.quarter,
    operator: data.operator,
    ct: data.ct,
    attr: data.attr,
    aggr: data.aggr,
    name: data.name,
    type: data.type,
    northEast: data.northEast,
    southWest: data.southWest,
    scoreTo: data.scoreTo,
    scoreFrom: data.scoreFrom,
    isDownloadEnabled: data.isDownloadEnabled,
    coordinates: data.coordinates,
    radius: data.radius,
    limit: perPage,
    page,
  };

  const response = await axiosMapInstance.post(
    `${baseUrl}/operator/heat-map/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    requestBody,{
      clearCacheEntry: data.level ? false : true,
    }
  );
  return response.data;
};

export const getOptrIBSMapDataCluster = async (data, perPage, page = 1) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/heat-map-cluster/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    {
      clearCacheEntry: data.level ? false : true,
      params: {
        quarter: data.quarter,
        operator: data.operator,
        ct: data.ct,
        attr: data.attr,
        aggr: data.aggr,
        name: data.name,
        type: data.type,
        northEast: data.northEast,
        southWest: data.southWest,
        scoreTo: data.scoreTo,
        scoreFrom: data.scoreFrom,
        limit: perPage,
        page,
      },
    }
  );
  return response.data;
};

export const getBestOptrIBSMapData = async (data, cancelToken, perPage, page = 1) => {
  const requestBody = {
    quarter: data.quarter,
    ct: data.ct,
    attr: data.attr,
    aggr: data.aggr,
    name: data.name,
    type: data.type,
    northEast: data.northEast,
    southWest: data.southWest,
    scoreTo: data.scoreTo,
    scoreFrom: data.scoreFrom,
    isDownloadEnabled: data.isDownloadEnabled,
    coordinates: data.coordinates,
    radius: data.radius,
    limit: perPage,
    page,
  };

  const response = await axiosMapInstance.post(
    `${baseUrl}/operator/best-op-heat-map/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    requestBody, {clearCacheEntry: data.level ? false : true}
  );
  return response.data;
};

export const getBestOptrIBSMapDataCluster = async (data, perPage, page = 1) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/best-op-heat-map-cluster/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    {
      clearCacheEntry: data.level ? false : true,
      params: {
        quarter: data.quarter,
        ct: data.ct,
        attr: data.attr,
        aggr: data.aggr,
        name: data.name,
        type: data.type,
        northEast: data.northEast,
        southWest: data.southWest,
        scoreTo: data.scoreTo,
        scoreFrom: data.scoreFrom,
        limit: perPage,
        page,
      },
    }
  );
  return response.data;
};

export const getIBSPolygonData = async (data, perPage, page = 1) => {
    const response = await axiosMapInstance.get(
      `${baseUrl}/polygon/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
      {
        clearCacheEntry: data.level ? false : true,
        params: {
          northEast: data.northEast,
          southWest: data.southWest,
          limit: perPage,
          page,
        },
      }
    );
    return response.data;
};

export const fetchTbsOprtTableData = async (data, page, limit, loader = false, cancelToken) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/table/${data.country}`,
    {
      params: {
        quarter: data.quarter,
        op: data.op,
        ct: data.ct,
        scoreFrom: data.scoreFrom,
        scoreTo: data.scoreTo,
        level: data.level,
        levelVal: data.levelVal,
        buildNames: data.buildNames,
        buildTypes: data.buildTypes,
        northEast: data.northEast,
        southWest: data.southWest,
        aggr: data.aggr,
        limit,
        page,
      },
      hideLoader: !loader,
      cancelToken: cancelToken.token,
    }
  );
  return response.data;
};

export const fetchBuildingLocatorSearch = async (data) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/locator/search/${data.country}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    {
      params: {
        quarter: data.quarter,
        searchVal: data.searchVal,
        poly: data.poly
      },
      hideLoader: true
    }
  );
  return response.data;
};

export const getTooltipData = async (data) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/tooltip/${data.country}`,
    {
      params: {
        quarter: data.quarter,
        op: data.operator,
        ct: data.ct,
        id: data.id,
        attr: data.attr,
        aggr: data.aggr,
        poly: data.poly
      },
    }
  );
  return response.data;
};

export const fetchMinMaxForAttr = async (data) => {
  const params = {
    quarter: data.quarter,
    ct: data.ct,
    attr: data.attr,
    aggr: data.aggr
  }
  if (data.op) params.op = data.op;
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/attr-range/${data.country}`,
    {
      params,
      hideLoader: true
    }
  );
  return response.data;
};